export enum ESlotStatus {
  Free = 'free',
  Approved = 'approved',
  Cancelled = 'cancelled',
  WaitingForPay = 'waitingForPay',
}
